import type { SelectElementProps } from 'react-hook-form-mui';
import { SelectElement } from 'react-hook-form-mui';

import { translateErrorMessage } from 'Common/Form/FormConsts';

type Option = {
  id: string | number;
  label: string;
  description?: string;
};

type Props = SelectElementProps & {
  name: string;
  label: string;
  options: Option[];
  required?: boolean;
  fullWidth?: boolean;
};

export const SelectField = ({
  name,
  label,
  options,
  required = false,
  fullWidth = true,
  ...props
}: Readonly<Props>) => (
  <SelectElement
    {...props}
    name={name}
    label={label}
    options={options}
    required={required}
    fullWidth={fullWidth}
    parseError={translateErrorMessage}
  />
);
